import mock from './index';

mock();
